import { render, staticRenderFns } from "./eventConfig.vue?vue&type=template&id=782af79f&scoped=true&"
import script from "./eventConfig.vue?vue&type=script&lang=js&"
export * from "./eventConfig.vue?vue&type=script&lang=js&"
import style0 from "./eventConfig.vue?vue&type=style&index=0&id=782af79f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782af79f",
  null
  
)

export default component.exports